export default "__VITE_ASSET__BybGv0V2__"